import type { WatchQueryFetchPolicy } from "@apollo/client";
import {
  GetPolicyListItemsQueryVariables,
  useGetPolicyListItemsQuery as useGetPolicyListItemsBaseQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting Policy list items based on the user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - policies list, total count, error and loading state.
 */
export function useGetPolicyListItemsQuery(
  variables: GetPolicyListItemsQueryVariables
) {
  const queryOptions: {
    fetchPolicy: WatchQueryFetchPolicy;
    variables: GetPolicyListItemsQueryVariables;
  } = { fetchPolicy: "cache-and-network", variables };

  const { data, error, loading, previousData } =
    useGetPolicyListItemsBaseQuery(queryOptions);

  return {
    error,
    loading: loading && !data,
    policies: data?.getPolicyListItems.items ?? [],
    totalCount:
      data?.getPolicyListItems.pagination.total ??
      previousData?.getPolicyListItems.pagination.total ??
      0,
  };
}
